"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Badge = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _badge = _interopRequireDefault(require("./badge.style"));
const Badge = exports.Badge = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
    appearance = undefined,
    className = 'badge',
    max,
    value = 0
  } = props;
  return (0, _jsxRuntime.jsx)(_badge["default"], (0, _extends2["default"])({
    className: className,
    role: "status",
    ref: ref,
    appearance: appearance,
    max: max,
    value: value
  }, {
    children: value !== undefined && value !== null && (0, _jsxRuntime.jsx)("span", {
      children: max && Number(value) > max && appearance !== 'removed' ? "".concat(max, "+") : "".concat(appearance === 'added' ? '+' : appearance === 'removed' ? '-' : '', " ").concat(value)
    })
  }));
});
var _default = exports["default"] = Badge;